import axiosInstance from "./api";

export const settingsService = {
  getSettings: () => axiosInstance.get("settings"),
  getBanners: (theater) =>
    axiosInstance.get(`banners/kiosk/theater/${theater}`),
};
